import apiService from '../../../services/api-client';
import { GetMeUserResponse } from '../interfaces/get-me-user';
import { PutMePasswordPayloadRequest, PutMePasswordResponse } from '../interfaces/put-me-password';
import { PutMeUserPayloadRequest, PutMeUserResponse } from '../interfaces/put-me-user';

export const meApiService = {
  async getMeUser() {
    const { data } = await apiService().get<GetMeUserResponse>(`/me/user`);
    return data;
  },
  async putMeUser(body: PutMeUserPayloadRequest) {
    const { data } = await apiService().put<PutMeUserResponse>(`/me/user`, body);
    return data;
  },
  async putMePassword(body: PutMePasswordPayloadRequest) {
    const { data } = await apiService().put<PutMePasswordResponse>(`/me/user/change-password`, body);
    return data;
  },
};
